import React, { Component } from 'react';
import Filters from '../../modules/Filters';
import { isTrue } from '../../helpers/isTrue';
import { withTranslation } from 'react-i18next';

class PageHeader extends Component {
    constructor(props) {
        super();
        this.additional_button_onClick = this.additional_button_onClick.bind(this);

        this.showRefreshAll = isTrue(props.is_superuser) || isTrue(props.from_no_data);
        window.gsc_report = props.gsc_report;
        window.waitMinMax = !isTrue(props.hide_filters || props.ignore_min_max);
    }

    async handleRefreshAll() {
        const warningBar = document.getElementById('warning-container');
        const hidenElements = window.hidenElements ?? [];

        hidenElements.forEach((element) => {
            if (element.classList.contains('hide-component')) {
                element.classList.remove('hide-component');
            } else {
                element.style.display = 'block';
            }
        });
        if (warningBar) warningBar.style.display = 'none';
        const filters = window.filters;
        if (window.refreshMinMax) {
            await window.refreshMinMax();
        }
        filters?.fns?.forEach((fn) => fn({ force: true, alreadyInQueue: true }));
    }

    additional_button_onClick() {
        if (this.props.addition_button_type === 'ai_tracking_add_project') {
            const event = new Event('ai_tracking_create_new_project');
            document.dispatchEvent(event);
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap w-100 mb-20">
                <h2 className={`page-title ${this.props.titleClassname || ''}`}>
                    {t(`${this.props.header}`, { defaultValue: this.props.header })}{' '}
                    {this.props.header_2}
                </h2>
                {!isTrue(this.props.hide_filters) && (
                    <div className="d-flex" style={{ zIndex: 1000 }}>
                        <Filters
                            gsc_report={this.props.gsc_report}
                            select_by_week={this.props.select_by_week}
                        />
                        {this.showRefreshAll && (
                            <div className="refresh-all-container">
                                <button
                                    className="refresh-all-btn"
                                    onClick={this.handleRefreshAll}
                                    title="Reload data"
                                >
                                    <i className="icon-Frame-converted" />
                                </button>
                            </div>
                        )}
                    </div>
                )}
                {this.props.additional_link && (
                    <div className="d-flex align-items-center gap-8">
                        {this.props.additional_button && (
                            <button
                                className={
                                    'button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center'
                                }
                                title={this.props.additional_link_hover_message ?? ''}
                                onClick={this.additional_button_onClick}
                            >
                                {t(`${this.props.additional_button}`, {
                                    defaultValue: this.props.additional_button,
                                })}
                            </button>
                        )}
                        {this.props.additional_link && (
                            <a
                                href={this.props.additional_link}
                                className={
                                    'button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center'
                                }
                                title={this.props.additional_link_hover_message ?? ''}
                            >
                                {this.props.additional_link_img && (
                                    <img
                                        className="mr-5"
                                        style={{ width: '20px' }}
                                        src={this.props.additional_link_img}
                                        alt="icon"
                                    />
                                )}
                                {this.props.additional_link_icon && (
                                    <i
                                        className={`${this.props.additional_link_icon} mr-5 color-white`}
                                    />
                                )}
                                {t(`${this.props.additional_link_name}`, {
                                    defaultValue: this.props.additional_link_name,
                                })}
                            </a>
                        )}
                        {this.props.additional_link_2 && (
                            <a
                                href={this.props.additional_link_2}
                                className={
                                    'button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center'
                                }
                                title={this.props.additional_link_hover_message_2 ?? ''}
                            >
                                {this.props.additional_link_img_2 && (
                                    <img
                                        className="mr-5"
                                        style={{ width: '20px' }}
                                        src={this.props.additional_link_img_2}
                                        alt="icon"
                                    />
                                )}
                                {this.props.additional_link_icon_2 && (
                                    <i
                                        className={`${this.props.additional_link_icon_2} mr-5 color-white`}
                                    />
                                )}
                                {t(`${this.props.additional_link_name_2}`, {
                                    defaultValue: this.props.additional_link_name_2,
                                })}
                            </a>
                        )}
                    </div>
                )}
                {this.props.additionalItem}
            </div>
        );
    }
}

export default withTranslation()(PageHeader);
